import React, { useEffect, useState, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { Table, InputNumber, Select, Form, DatePicker, Image, Avatar, Button, Row, Col, Upload, message } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const ModalBody = ({close, handleSubmit, user, update}) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [endDate, setEndDate] = useState('');
    const [permanent, setPermanent] = useState(false);
    const [elite, setElite] = useState(false);
    const [loading, setLoading] = useState(false);

    const [form] = Form.useForm();
    const uploadButton = (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );

    useEffect(() => {
        if(!user) {
            setEmail("");
            setPassword("");
            setEndDate("");
            setPermanent(false);
            setElite(false);
            form.setFieldsValue({
                email: "",
                password: "",
                endDate: "",
                permanent: false,
                elite: false
            })
            
            return;
        }

        setEmail(user.Email);
        setPassword(user.Password);
        setEndDate(user.EndDate);
        setPermanent(user.Permanent);
        setElite(user.Elite == 1? true : false);
        console.log("AAA_ELITE", user.Elite == 1? true : false);
        form.setFieldsValue({
            email: user.Email,
            password: user.Password,
            endDate: user.EndDate? user.EndDate : "",
            permanent: user.Permanent,
            elite: user.Elite == 1? true: false
        })
    }, [update])

    const onFinish = (values) => {
        handleSubmit({
            email: email,
            password: password,
            endDate: endDate,
            permanent: permanent,
            elite: elite
        })
    }

    return (
        <Form onFinish={onFinish} form={form}>
            <div className="form form--horizontal">
                <Row gutter={16} style={{width: '100%'}}>
                    <Col span={24}>
                        <Form.Item name="email" label="Email"
                            rules={[
                                {
                                    required: true,
                                    message: `Email is required!`,
                                },
                            ]}>
                            <input
                                name="email"
                                type="text"
                                value={email}
                                placeholder="Email"
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item name="password" label="Password"
                            rules={[
                                {
                                    required: !user? true : false,
                                    message: `Password is required!`,
                                },
                            ]}>
                            <input
                                name="password"
                                type="text"
                                value={password}
                                placeholder="Password"
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item name="endDate" label="End Date">
                            <input
                                name="endDate"
                                type="date"
                                placeholder="End Date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </Form.Item>
                        
                        <Form.Item name="permanent" label="Permanent Lifetime Access">
                            <input
                                name="permanent"
                                type="checkbox"
                                checked={permanent}
                                value={permanent}
                                placeholder="Permanent Lifetime Access"
                                onChange={(e) => setPermanent(e.target.checked)}
                            />
                        </Form.Item>

                        <Form.Item name="elite" label="Elite Access">
                            <input
                                name="elite"
                                type="checkbox"
                                checked={elite}
                                value={elite}
                                placeholder="Elite Access"
                                onChange={(e) => setElite(e.target.checked)}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </div>
            <Row style={{justifyContent: 'center'}}>
                <Button type="text" onClick={close}>Cancel</Button>
                <Button type="primary" htmlType="submit">{user ? 'Update' : 'Add'}</Button>
            </Row>
        </Form>
        
    )
}

export default ModalBody;